import createClient from "openapi-fetch";
import { paths } from "../types/platform/v1";
import { getEnvVar } from "./utils";


const platformClient = createClient<paths>({
    baseUrl: getEnvVar('VITE_API_BASE_URL') || "http://localhost:8086/platform/",
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  });

  
export default platformClient;